import React from 'react';
import { useFormikContext } from 'formik';

import ProjectInfoPanel from 'components/ProjectInfoPanel/ProjectInfoPanel';

export interface FormikProjectInfoPanelProps<T> {
  label: string | JSX.Element;
  fieldName: string;
  className?: string;
  withBorder?: boolean;
  variant?: 'traro' | 'kliparo' | 'prosfora';
  valueFormatter: (value: T) => string;
}

const defaultValueFormatter = (value: unknown): string => String(value);

const FormikProjectInfoPanel = <T,>({
  fieldName,
  valueFormatter = defaultValueFormatter,
  ...props
}: FormikProjectInfoPanelProps<T>) => {
  const { getFieldMeta } = useFormikContext();
  const { value } = getFieldMeta<T>(fieldName);

  return <ProjectInfoPanel {...props} value={valueFormatter(value)} />;
};

export default FormikProjectInfoPanel;
